<template>
  <gj-modal
      size="middle-height-auto"
      v-bind="$attrs"
      v-on="$listeners"
      class="sale-order-refund-modal"
      :visible.sync="modalVisible">
    <template #header>订单退款</template>

    <template #content>
      <div style="min-height: 600px; max-height: 700px; overflow-y: auto; overflow-x: hidden">
        <div v-for="(item, index) in data" :key="index" :class="{'mb20': index + 1 !== data.length}">
          <el-row style="margin-bottom: 12px">
            <el-col :span="16">
              <div style="display: flex">
                <div style="margin-right: 4px">
                  <gj-image size="50" :src="item.imageUrl"></gj-image>
                </div>
                <div style="font-size: 12px">
                  <div>{{item.title}}</div>
                  <div>
                    <label style="color: #666;">数量：</label>
                    <label style="color: #444">{{item.quantity}}</label>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="8" style="text-align: right">
              <gj-select
                  v-model="item.refundReason"
                  :options="reasons"
                  width="200px"
                  placeholder="请选择原因"
                  :clearable="false"
              ></gj-select>
            </el-col>
          </el-row>
          <el-row>
            <gj-table
                :columns="columns"
                :data="item.details"
                :index="false"
                :show-pagination="false"
                :show-summary="true"
                :adaptHeight="false"
                :summary-method="getSummaries"
                class="refund-table-right"
            >
              <template v-slot:amount="{row}">
                {{item.currencySymbol}}{{row.amount}}
              </template>
              <template v-slot:refundedPrice="{row}">
                {{item.currencySymbol}}{{row.refundedPrice}}
              </template>
              <template v-slot:refundPrice="{row}">
                <gj-input
                    v-model="row.refundPrice"
                    width="120px"
                >
                  <template #prepend>
                    {{item.currencySymbol}}
                  </template>
                </gj-input>
              </template>
              <template v-slot:allRefund="{row}">
                <template v-if="row.type !== 'Goodwill'">
                  可退金额: {{item.currencySymbol}}{{row.amount - row.refundedPrice}}
                </template>
                <template v-else>-</template>
              </template>
              <template v-slot:header:allRefund>
                <el-checkbox @change="changeAllRefund($event, index)"><span
                    style="font-size: 12px; color: #909399; font-weight: bold;">全部退款</span></el-checkbox>
              </template>
            </gj-table>
          </el-row>
        </div>
      </div>
    </template>
    <template #footer>
      <gj-button @click="cancel">关闭</gj-button>
      <gj-button type="primary" @click.stop="refund" :loading="loading">退款</gj-button>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";
  import {isNotBlank} from "../../../../../utils/common";
  import {buildRefundOrder} from "../../../../../api/sale";

  export default {
    name: "sale-order-refund",
    props: {
      id: {
        type: Number,
        require: true,
      },
    },
    mixins: [modalMixIn],
    created() {
      buildRefundOrder(this.id).then((data) => {
        this.data = data;
      })
    },
    data() {
      return {
        data: {},
        columns: [
          {id: 'feeType', header: '费用项', field: 'name', minWidth: '80px', default: true},
          {id: 'orderAmount', header: '订单金额', field: 'slot:amount', minWidth: '100px', default: true, align: 'right'},
          {
            id: 'refunded',
            header: '已退金额',
            field: 'slot:refundedPrice',
            minWidth: '100px',
            default: true,
            align: 'right'
          },
          {
            id: 'refundAmount',
            header: '退款金额',
            field: 'slot:refundPrice',
            minWidth: '100px',
            default: true,
            align: 'right'
          },
          {
            id: 'allRefund',
            header: 'slot:allRefund:aa',
            field: 'slot:allRefund',
            minWidth: '100px',
            default: true,
            align: 'right'
          },
        ],
        reasons: [
          {id: 'NoInventory,', text: 'NoInventory'},
          {id: 'CustomerReturn,', text: 'CustomerReturn'},
          {id: 'GeneralAdjustment,', text: 'GeneralAdjustment'},
          {id: 'CouldNotShip,', text: 'CouldNotShip'},
          {id: 'DifferentItem,', text: 'DifferentItem'},
          {id: 'Abandoned,', text: 'Abandoned'},
          {id: 'CustomerCancel,', text: 'CustomerCancel'},
          {id: 'PriceError,', text: 'PriceError'},
          {id: 'ProductOutofStock,', text: 'ProductOutofStock'},
          {id: 'CustomerAddressIncorrect,', text: 'CustomerAddressIncorrect'},
          {id: 'Exchange,', text: 'Exchange'},
          {id: 'Other,', text: 'Other'},
          {id: 'CarrierCreditDecision,', text: 'CarrierCreditDecision'},
          {id: 'RiskAssessmentInformationNotValid,', text: 'RiskAssessmentInformationNotValid'},
          {id: 'CarrierCoverageFailure,', text: 'CarrierCoverageFailure'},
          {id: 'TransactionRecord', text: 'TransactionRecord'},
        ],
        loading: false,
      }
    },
    methods: {
      refund() {
        let flag = false;
        this.data.forEach(val => {
          if (val.details.some(v => v.type !== 'Goodwill' && v.refundPrice > (v.amount - v.refundedPrice) )) {
            flag = true;
          }
        });
        if (flag) {
          this.$gjMessage.error('除【其他优惠】以外，退款金额不能超过可退金额');
          return;
        }
        this.$emit('refund', this.data)
      },
      changeAllRefund(event, index) {
        this.data[index].details.forEach(val => {
          if (event) {
            val.refundPrice = val.amount - val.refundedPrice;
          } else {
            val.refundPrice = 0;
          }
        })
      },
      getSummaries(params) {
        const {columns, data} = params;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '小计';
            return;
          }

          const values = data.map(item => Number(item[column.property.split(':')[1]]));
          if (values.every(val => !isNaN(val))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0).toFixed(2);
            let str = '';
            if (this.data && this.data.length > 0) {
              str = this.data[0].currencySymbol;
            }
            sums[index] = str + sums[index];
          } else {
            sums[index] = '-';
          }
        });
        return sums;
      },
      isNotBlank(memo) {
        return isNotBlank(memo)
      },
      clickMemo() {
        this.memoFlag = false;
      },
      memoBlur() {
        this.memoFlag = true;
      },
    }
  }
</script>

<style scoped>
  .refund-table-right {
  }

  /deep/ .refund-table-right.gj-table .cell {
    padding-right: 8px;
  }

  .detail-memo-color {
    color: #bbb;
    font-size: 12px;
  }

  /deep/ .gj-modal--custom .el-dialog {
    height: 600px !important;
    width: 800px !important;
  }

  .sale-order-refund-modal /deep/ .el-dialog__body{
    padding: 16px 12px;
  }

  .mb-top12 {
    margin-top: 12px;
  }

  .detail-title {
    margin-bottom: 12px;
  }

  .mb20 {
    margin-bottom: 20px;
  }
</style>
